import BaseController from "../sharedControllers/BaseController";
import { Routes } from "akademika/akamont/constants/Routes";

/**
 * @namespace akademika.akamont.pages.serviceList
 */
export default class ServiceList extends BaseController {
  route = Routes.SERVICE_LIST;
  parentRoute = Routes.DASHBOARD;

  public async onRouteMatched() {
    await this.fetchModel("api/Service/GetServiceList");
  }

  public async onServiceDetails(serviceId: number) {
    this.navTo(Routes.SERVICE_DETAILS, { serviceId });
  }

  public async onAddService() {
    this.navTo(Routes.SERVICE_ADD);
  }
}
